export default __webpack_public_path__ + "static/media/annuity_light.8679a8fc.png";